const styles = theme => ({
  root: {
    gridColumnStart: 2,
    padding: theme.spacing(5, 0),
  },
  createscorecardwrap: {
    margin: '3rem 0'
  },
  formbox: {
    // maxWidth: '600px',
    display: 'grid',
    gap: '2rem',
    gridTemplateColumns: '1fr 1fr'
  },
  headingwrp: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    padding: '1rem 0',
    borderBottom: '1px dashed #ccc',
    marginBottom: '2rem',
  },
  title: {
    margin: '0px',
    textAlign: 'left',
    fontSize: '1.5rem',
    fontFamily: "VodafoneRg-bold",
  },
  heading: {
    margin: '0px',
    textAlign: 'left',
    fontSize: '1.125rem',
    fontFamily: "VodafoneRg-bold",
  },
  labels: {
    color: '#333',
    fontSize: '1.125rem',
    fontFamily: 'VodafoneRg-bold',
    marginBottom: '1rem',
    marginTop: 0,
    display: 'inline-block'
  },
  inputs: {
    width: '100%',
    minHeight: '2.8rem',
    padding: '0.5rem',
    boxSizing: 'border-box',
    fontSize: '1rem',
    fontFamily: 'VodafoneRg-Regular',
    marginBottom: '0.5rem'
  },
  viewlink: {
    backgroundColor: '#e60000',
    border: '1px solid #e60000',
    color: '#fff',
    // width: '100%',
    display: 'block',
    padding: '1rem',
    'box-sizing': 'border-box',
    textAlign: 'center',
    fontSize: '1rem',
    fontFamily: "VodafoneRg-Regular",
    borderRadius: '5px',
    transition: 'all 300ms ease',
    margin: '1rem 0 1rem 0',
    '&:hover': {
      background: 'transparent',
      border: '1px solid #e60000',
      color: '#333'
    }
  },
  error: {
    margin: '0 0 1rem 0',
    fontSize: '1rem',
    fontFamily: "VodafoneRg-Regular",
    color: 'red'
  },
  noFoundtemplateAreaWpr: {
    textAlign: 'center',
    margin: '2rem 0px',
  },
  notFoundContent: {
    margin: '0px',
    fontSize: '2.125rem',
    fontFamily: "VodafoneRg-bold",
  },
  notFoundContentSmall: {
    margin: '0px',
    fontSize: '1rem',
    fontFamily: "VodafoneRg-Regular",
  },
  notFoundImg: {
    maxWidth: '25rem',
    margin: '2rem auto',
    display: 'block'

  },
  scorecardName: {
    textAlign: 'center',
    margin: '0 0 1rem 0',
    fontSize: '1.5rem',
    fontFamily: "VodafoneRg-bold",
    borderBottom: '1px dashed #333',
    padding: '1rem 0 1rem 0',
    transition: 'all 300ms ease',

  },
  scorecardItem: {
    borderRadius: '1rem',
    padding: '1rem',
    border: '1px solid #ccc',
    overflow: 'hidden',
    position: 'relative',
    'z-index': '11',
    '& .alignbtn': {
      position: 'absolute',
      right: '0',
      top: '0'
    }
  },
  noimg: {
    display: 'block',
    width: '3rem',
    height: '3rem',
    borderRadius: '50rem',
    'box-shadow': '0 1px 1px #333',
  },
  avtarContent: {
    display: 'flex',
    gap: '1rem',
    width: '100%',
    '& p': {
      margin: '0 0 0.5rem',
      fontSize: '1rem',
      '& span': {
        fontFamily: "VodafoneRg-bold",
      }
    },

  },
  avtarDetails: {
    width: '100%'
  },
  templateCols: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, minmax(300px, 1fr))`,
    gap: '1rem',
    margin: '2.5rem 0'
  },
  activelistWrap: {
    margin: '1rem 0px',
    borderTop: '1px dashed #333',
  },
  activeTitle: {
    margin: '0.5rem 0',
    fontSize: '1.125rem',
    fontFamily: "VodafoneRg-bold",
  },
  listChallenge: {
    listStyle: 'circle',
    margin: '0',
    padding: '0 0 0 1rem',

    '& li': {
      margin: '0 0 0.5rem 0',

      '& a': {
        color: '#0096e2',
        fontSize: '1rem',
        fontFamily: "VodafoneRg-Regular",
        display: 'block',
        transition: 'all 300ms ease'
      },
      '& a:hover': {
        color: '#333'
      }
    }
  },

  // overlay:{
  //     background:'rgba(0,0,0,0.7)',
  //     width:'100%',
  //     height:'25%',
  //     position:'absolute',
  //     top:'0',
  //     left:'0',
  //     display:'flex',
  //     alignItems:'center',
  //     justifyContent:'center',
  //     opacity:0,
  //     'z-index':'1'
  // },

  // btns:{
  //     width:'5rem',
  //     background:'#fff',
  //     borderRadius:'5rem',
  //     border:'0',
  //     margin:'0 0.5rem 0.5rem 0',
  //     fontSize: '1rem',
  //     fontFamily: "VodafoneRg-Regular",
  //     padding:'0.3rem',
  //     cursor:'pointer'
  // }
  btns: {
    width: '5rem',
    background: '#0096fb',
    borderRadius: '0rem',
    border: '0',
    margin: '0',
    fontSize: '1rem',
    fontFamily: "VodafoneRg-Regular",
    padding: '0.3rem',
    cursor: 'pointer',
    color: '#fff',
  },
  overallBox: {
    // maxWidth: '600px'
  },
  overallHeading: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#333',
    color: '#fff',
    alignItems: 'center',
    padding: '0.5rem'
  },
  overallWeightRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.5rem',
    alignItems: 'center',
    '&:nth-child(odd)': {
      background: '#ccc'
    },
    '&:nth-child(even)': {
      background: '#f7f7f7'
    },
  },
  notes: {
    fontStyle: 'italic',
    fontWeight: '900',
    fontSize: '0.815rem',
    color: 'red'
  }

})

export default styles
